import { c as _c } from "react/compiler-runtime";
import { t } from 'i18next';
import Image from 'next/image';
import { HiChevronRight } from 'react-icons/hi';
import i18n from '@/src/i18n';
import { sendAnalyticsData, trackGetStartedClicked } from '@/src/utils/analytics';
import { StartTrialInput } from '../StartTrialInput';
const styles = {
  container: {
    background: 'linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 64.35%, #F2FAFF 100%)'
  }
};
function Heading(t0) {
  const $ = _c(9);
  const {
    customHeading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["Get Started with", "AbleSpace for FREE!"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const defaultHeading = t1;
  const heading = customHeading || defaultHeading;
  let t2;
  if ($[1] !== heading[0]) {
    t2 = i18n.t(heading[0] || "");
    $[1] = heading[0];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== heading[1]) {
    t4 = i18n.t(heading[1] || "");
    $[4] = heading[1];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="px-4 text-center text-[28px] font-medium text-[#3D3E40] md:px-0 md:text-left md:text-[36px]">{t2}{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function EmailInput() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <input type="email" placeholder="Enter your email Address" className="h-[58px] flex-grow rounded-l-lg border-2 border-r-0 border-[#E4E4E4] bg-white px-5 py-4 text-base font-normal text-[#787878] md:w-[230px] lg:w-[300px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full flex-col items-center justify-between md:items-start md:gap-6"><div className="flex w-full">{t0}<button className="flex h-[58px] items-center justify-center rounded-r-lg bg-[#318AE5] px-4 text-base text-white focus:outline-none" onClick={_temp}><div className="flex items-center gap-1"><p className=" whitespace-nowrap md:text-lg ">{t("Start for Free!")}</p><HiChevronRight size={24} /></div></button></div><div><p className="mt-4 pl-2 text-[18px] font-normal text-[#616366]">No Credit Card Required. Cancel Anytime 🙌</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  sendAnalyticsData("START_FOR_FREE_BUTTON_CLICKED_FROM_FOOTER");
  trackGetStartedClicked("Start for Free!");
}
function TextArea(t0) {
  const $ = _c(7);
  const {
    useEmail: t1,
    heading
  } = t0;
  const useEmail = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== heading) {
    t2 = <Heading customHeading={heading} />;
    $[0] = heading;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== useEmail) {
    t3 = useEmail ? <div className="mt-4 flex flex-col px-10 md:px-0"><EmailInput /></div> : <div className="mt-4 flex flex-col px-10 md:px-0"><StartTrialInput /></div>;
    $[2] = useEmail;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="mt-6 flex w-full flex-col items-center md:order-1 md:mt-0 md:max-w-[80%] md:items-start lg:max-w-[65%] xl:max-w-[50%]">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export const Footertop = t0 => {
  const $ = _c(4);
  const {
    useEmail,
    heading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="protect-img w-[60%] md:order-2 md:w-[40%] xl:w-[30%]"><Image className="mx-auto md:mx-0" src="/images/footer-top.svg" alt="Kickstart your journey with a generous 1-month free trial. No strings attached." width={600} height={600} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== heading || $[2] !== useEmail) {
    t2 = <div style={styles.container} className="overflow-hidden bg-origin-padding py-10 md:m-auto md:w-[90%] md:px-6 lg:w-[100%] lg:px-20 lg:py-16"><div className="container mx-auto flex flex-col items-center justify-center md:w-full md:flex-row">{t1}<TextArea useEmail={useEmail} heading={heading} /></div></div>;
    $[1] = heading;
    $[2] = useEmail;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};